/**
 * Header component with project selector and user menu
 */

import React from 'react';
import { TenantSelector } from '../Workspace/TenantSelector';
import { ProjectSelector } from '../Workspace/ProjectSelector';
import { UserMenu } from './UserMenu';
import { HelpCenterButton } from '../HelpCenter';
import { NotificationButton } from '../Notifications/NotificationButton';
import { HeaderFeedbackButton } from '../Feedback/HeaderFeedbackButton';

export interface HeaderProps {
  pluginActions?: React.ComponentType<any>[];
  defaultTenantId?: string;
  defaultProjectId?: string;
  /** When false, tenant/project dropdowns and On-Premise badge are hidden; workspace is synced to config defaults. */
  showWorkspaceSelectors?: boolean;
  sidebarCollapsed?: boolean;
  onToggleSidebar?: () => void;
  onNavigate?: (path: string) => void;
}

export function Header({ 
  pluginActions = [], 
  defaultTenantId, 
  defaultProjectId,
  showWorkspaceSelectors = true,
  onNavigate
}: HeaderProps) {
  return (
    <header 
      className="sticky top-0 z-30 backdrop-blur-xl border-b shadow-sm h-16 flex items-center justify-between px-8"
      style={{
        backgroundColor: 'var(--color-header-bg, rgba(255, 255, 255, 0.9))',
        borderColor: 'var(--color-header-border, rgba(226, 232, 240, 0.6))',
        color: 'var(--color-header-text, #111827)'
      }}
    >
      {/* Left: Workspace selectors (tech admin only); when hidden, workspace is synced to hardcoded tenant/project in App */}
      <div className="flex items-center gap-4">
        
          {/* {showWorkspaceSelectors && (
            <>
              <TenantSelector defaultTenantId={defaultTenantId} />
              <ProjectSelector defaultProjectId={defaultProjectId} />
            </>
          )} */}
       
      </div>
      
      {/* Right: Actions and user */}
      <div className="flex items-center gap-4">
        {pluginActions.map((Action, idx) => (
          <Action key={idx} />
        ))}

        {/* Global Feedback Button */}
        <HeaderFeedbackButton projectId={defaultProjectId} />
        
        {/* Notification Button */}
        <NotificationButton />
        
        {/* Help Center Button */}
        <HelpCenterButton />
        
        {/* User menu */}
        <div 
          className="pl-4 border-l"
          style={{
            borderColor: 'var(--color-header-border, #e2e8f0)'
          }}
        >
          <UserMenu onNavigate={onNavigate} />
        </div>
      </div>
    </header>
  );
}

